import { render, staticRenderFns } from "./PayrollDurationInput.vue?vue&type=template&id=df064ee0&scoped=true&"
import script from "./PayrollDurationInput.vue?vue&type=script&lang=js&"
export * from "./PayrollDurationInput.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDurationInput.vue?vue&type=style&index=0&id=df064ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df064ee0",
  null
  
)

export default component.exports